import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import DownloadIcon from "@mui/icons-material/Download";

interface Props {
  onGenerateFlyer?: () => void;
  onDownloadFLyer?: () => void;
}
export const ExportFlyerButton = ({
  onGenerateFlyer,
  onDownloadFLyer,
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div data-testid="generate-flyer-button">
      <Button
        id="export-button"
        aria-controls={open ? "export-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ textTransform: "capitalize" }}
        startIcon={<DownloadIcon></DownloadIcon>}
      >
        Flyers
      </Button>
      <Menu
        id="export-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "export-button",
        }}
      >
        <MenuItem
          data-testid="generate-flyer-button-generate"
          onClick={onGenerateFlyer}
        >
          Generate
        </MenuItem>
        <MenuItem
          data-testid="generate-flyer-button-download"
          onClick={onDownloadFLyer}
        >
          Download
        </MenuItem>
      </Menu>
    </div>
  );
};
